(function (global) {
  'use strict';

  var PRICE_SELECTOR = '[data-tf-preset-bundle-price]';

  function isPositiveWholeNumber(value) {
    return /^[1-9]\d*$/.test(value);
  }

  function formatWithDelimiters(cents, precision, thousandsSeparator, decimalSeparator) {
    var amount;
    var parts;
    var whole;

    if (!Number.isInteger(cents) || cents < 0) {
      return null;
    }

    amount = (cents / 100).toFixed(precision);
    parts = amount.split('.');
    whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

    return parts.length > 1 ? whole + decimalSeparator + parts[1] : whole;
  }

  function formatMoney(cents) {
    var settings = global.themeVariables && global.themeVariables.settings;
    var moneyFormat = settings && settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings && settings.moneyFormat;
    var placeholder;
    var formattedAmount;

    if (!moneyFormat || !Number.isInteger(cents) || cents < 0) {
      return null;
    }

    placeholder = moneyFormat.match(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/);

    if (!placeholder) {
      return null;
    }

    switch (placeholder[1]) {
      case 'amount':
        formattedAmount = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        formattedAmount = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formattedAmount = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formattedAmount = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        return null;
    }

    return formattedAmount === null ? null : moneyFormat.replace(placeholder[0], formattedAmount);
  }

  function enhancePrice(price, policyApi, policy) {
    var pieceCountText = price.getAttribute('data-piece-count') || '';
    var currentSellingPriceCents = Number(price.getAttribute('data-current-selling-price-cents'));
    var effectivePrice = price.querySelector('[data-tf-preset-bundle-effective-price]');
    var parentPrice = price.querySelector('[data-tf-preset-bundle-parent-price]');
    var parentCompareAtPrice = price.querySelector('[data-tf-preset-bundle-parent-compare-at-price]');
    var saving = price.querySelector('[data-tf-preset-bundle-saving]');
    var percentage = price.querySelector('[data-tf-preset-bundle-percentage]');
    var hasPriceMessage = price.querySelector('[data-tf-preset-bundle-price-message]') !== null;
    var progress;
    var savingCents;
    var effectivePriceText;

    if (
      !effectivePrice ||
      !parentPrice ||
      (hasPriceMessage && (!saving || !percentage)) ||
      !isPositiveWholeNumber(pieceCountText) ||
      !Number.isInteger(currentSellingPriceCents) ||
      currentSellingPriceCents < 0 ||
      policy.state !== 'active'
    ) {
      return;
    }

    progress = policyApi.resolveProgress(policy, Number(pieceCountText));

    if (!progress.currentTier || typeof progress.currentTier.percentage !== 'number' || !Number.isFinite(progress.currentTier.percentage)) {
      return;
    }

    savingCents = policyApi.calculateSaving(currentSellingPriceCents, progress.currentTier.percentage);

    if (!Number.isInteger(savingCents) || savingCents <= 0 || savingCents > currentSellingPriceCents) {
      return;
    }

    effectivePriceText = formatMoney(currentSellingPriceCents - savingCents);

    if (!effectivePriceText) {
      return;
    }

    effectivePrice.textContent = effectivePriceText;
    price.classList.add('tf-preset-bundle-price');
    parentPrice.classList.add('tf-preset-bundle-price__parent');
    if (parentCompareAtPrice) {
      parentCompareAtPrice.hidden = true;
    }

    if (hasPriceMessage) {
      percentage.textContent = String(progress.currentTier.percentage);
      saving.hidden = false;
    }

    effectivePrice.hidden = false;
  }

  function enhancePrices() {
    var policyApi = global.TheFaithMultibuy;
    var policy;
    var prices;

    if (
      !policyApi ||
      typeof policyApi.readPolicy !== 'function' ||
      typeof policyApi.resolveProgress !== 'function' ||
      typeof policyApi.calculateSaving !== 'function' ||
      !global.document
    ) {
      return;
    }

    policy = policyApi.readPolicy();

    if (!policy || policy.state !== 'active') {
      return;
    }

    prices = global.document.querySelectorAll(PRICE_SELECTOR);

    for (var index = 0; index < prices.length; index += 1) {
      enhancePrice(prices[index], policyApi, policy);
    }
  }

  global.TheFaithPresetBundlePricing = {
    enhancePrices: enhancePrices
  };

  if (global.document && global.document.readyState === 'loading') {
    global.document.addEventListener('DOMContentLoaded', enhancePrices);
  } else {
    enhancePrices();
  }

  if (global.document) {
    global.document.addEventListener('variant:change', enhancePrices);
    global.document.addEventListener('tf:collection-results-replaced', enhancePrices);
  }
})(typeof window !== 'undefined' ? window : globalThis);
